import { v4 as uuidv4 } from "uuid";
export class AssetRepairHistoryModel {
    constructor() {
        this.id = uuidv4();
        this.assetId = "";
        this.returnedFromRepairOn = "";
        this.sentToRepairOn = "";
    }
}
export default class AssetHistory extends AssetRepairHistoryModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
